export function initiateColorSwitch(switchColors, bgColorsMap, minutes) {
  const key = getMinuteKeyToRead(bgColorsMap, minutes);
  const colorConfig = bgColorsMap?.[key] || [];
  switchColors(colorConfig[0], colorConfig[1]);
}

function getMinuteKeyToRead(bgColorsMap, minutes) {
  // sort in descending order
  const minutesList = Object.keys(bgColorsMap || {}).sort((a: any, b: any) => (a - b ? -1 : 0));
  let key = minutesList[0];
  minutesList.forEach((minut) => {
    if (minut > minutes || +minut == -1) {
      key = minut;
    }
  });
  return key;
}
